/* @flow */
import { Map } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { detailPanelRecord } from './types';
import type { Action } from 'trustar/utils/redux-types';
import type { PositionsType, DetailPanelRecordType } from './types';
import {
  STORE_SCROLL_POSITION,
  SET_DETAIL_PANEL_OPTIONS,
} from './action-types';
import { SET_ACTIVE_NOTE } from 'modules/constellation/action-types';

// State for scroll positioning in the Explore View for Reports, Indicators, and Search Results
const scroll = (state: PositionsType = Map(), action: Action<*>): PositionsType => {
  const { type, payload } = action;

  switch (type) {
  case STORE_SCROLL_POSITION:
    return state.set(payload.key, payload.value);
  default:
    return state;
  }
};

// State for display options of the Details Panel in Analysis View
const detailPanel = (state: DetailPanelRecordType = detailPanelRecord(), action: Action<*>): DetailPanelRecordType => {
  const { type, payload } = action;

  switch (type) {
  case SET_DETAIL_PANEL_OPTIONS:
    return state.merge(payload);
  case SET_ACTIVE_NOTE:
    return state.merge({ detailType: 'notes' });
  default:
    return state;
  }
};

export default combineReducers({
  scroll,
  detailPanel,
});



// WEBPACK FOOTER //
// ./src/app/modules/display/stores.js